import { Json } from '@gift/types/Json';
import { edit } from './mergeInputsIntoPrefab';

export function mergeAssetIntoPrefab(
    prefabInput: Json.Input<any>,
    userInput: Json.Input<any>
): Json.Input<any> {

    const fromPrefab = prefabInput.value;
    const fromUser = userInput.value;

    return edit(prefabInput, {
        assetUrl: fromUser.assetUrl || fromPrefab.assetUrl
    });
}